import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { CONFIG_AUSENTE } from './lib/auth-config'
import { AcessoNegadoPage, LoginPage } from './auth/LoginPage'
import { RequireAuth } from './auth/RequireAuth'
import { AppLayout } from './layout/AppLayout'
import { AcompanhamentoPage } from './pages/AcompanhamentoPage'
import { AlimentosPage } from './pages/AlimentosPage'
import { AuditoriaPage } from './pages/AuditoriaPage'
import { CalendarioPage } from './pages/CalendarioPage'
import { FichaTecnicaPage } from './pages/FichaTecnicaPage'
import { ConfiguracoesPage } from './pages/ConfiguracoesPage'
import { ComprasPage } from './pages/ComprasPage'
import { ContratoPage } from './pages/ContratoPage'
import { DashboardPage } from './pages/DashboardPage'
import { EntregasPage } from './pages/EntregasPage'
import { EstoquePage } from './pages/EstoquePage'
import { PlanejamentoRotaPage } from './pages/PlanejamentoRotaPage'

function Protected({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <AppLayout>{children}</AppLayout>
    </RequireAuth>
  )
}

/**
 * Build de produção sem Supabase configurado. Antes a aplicação abria em modo
 * local como administrador; agora para aqui, com a causa na tela.
 */
function ConfiguracaoAusente() {
  return (
    <div className="login-page">
      <div className="alert alert-error" style={{ maxWidth: 520, margin: '48px auto' }}>
        <strong>Configuração ausente</strong>
        <p style={{ marginTop: 8 }}>
          As chaves do Supabase não chegaram à aplicação. Defina VITE_SUPABASE_URL e
          VITE_SUPABASE_ANON_KEY no Environment do servidor e publique novamente.
        </p>
      </div>
    </div>
  )
}

export default function App() {
  if (CONFIG_AUSENTE) {
    return <ConfiguracaoAusente />
  }

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/acesso-negado" element={<AcessoNegadoPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <DashboardPage />
              </Protected>
            }
          />
          <Route
            path="/acompanhamento"
            element={
              <Protected>
                <AcompanhamentoPage />
              </Protected>
            }
          />
          <Route path="/escolas" element={<Navigate to="/configuracoes?tab=escolas" replace />} />
          <Route
            path="/calendario"
            element={
              <Protected>
                <CalendarioPage />
              </Protected>
            }
          />
          <Route path="/cardapio" element={<Navigate to="/ficha-tecnica" replace />} />
          <Route
            path="/ficha-tecnica"
            element={
              <Protected>
                <FichaTecnicaPage />
              </Protected>
            }
          />
          <Route
            path="/alimentos"
            element={
              <Protected>
                <AlimentosPage />
              </Protected>
            }
          />
          <Route path="/rotas" element={<Navigate to="/configuracoes?tab=rotas" replace />} />
          <Route
            path="/planejamento-rota"
            element={
              <Protected>
                <PlanejamentoRotaPage />
              </Protected>
            }
          />
          <Route
            path="/entregas"
            element={
              <Protected>
                <EntregasPage />
              </Protected>
            }
          />
          <Route
            path="/estoque"
            element={
              <Protected>
                <EstoquePage />
              </Protected>
            }
          />
          <Route path="/indicadores" element={<Navigate to="/" replace />} />
          <Route
            path="/contrato"
            element={
              <Protected>
                <ContratoPage />
              </Protected>
            }
          />
          <Route path="/compras" element={<Navigate to="/pedido-mensal" replace />} />
          <Route
            path="/pedido-mensal"
            element={
              <Protected>
                <ComprasPage />
              </Protected>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <Protected>
                <ConfiguracoesPage />
              </Protected>
            }
          />
          <Route
            path="/auditoria"
            element={
              <Protected>
                <AuditoriaPage />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
